module.exports = __webpack_public_path__ + "img/nx_v1_1.2b195490.png";